<nav class="sidebar" [ngClass]="{'hidden': hideSideNav}">
    <!-- Toggle Button -->
    <div class="toggle-btn" (click)="hideSideBar()">
        <i class="fas" [ngClass]="hide ? 'fa-angle-double-left' : 'fa-angle-double-right'"></i>
    </div>

    <!-- Sidebar Content -->
    <div *ngIf="hide" class="sidebar-content">
        <!-- Logo -->
        <!-- <div class="logo">
            <a [routerLink]="['/core']" (click)="clickOnImg()">
                <img src="assets/bk_logo.png" alt="App Logo" />
            </a>
        </div> -->

        <!-- Accordion Menu -->
        <div class="menu-container">
            <mat-accordion>
                <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
                    *ngFor="let menu of menuList; index as i" (opened)="menuClick(i)">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <!-- <i class="fas fa-folder-open"></i> -->
                            <span>{{menu.functionShortName}}</span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="submenu-container">
                        <ul *ngFor="let submenu of subMenuList; index as i">
                            <li [ngClass]="{'active': isActive(submenu)}" (click)="subMenuClick(submenu)">
                                <i class="fas fa-angle-right"></i>
                                <span>{{submenu.subFunctionShortName}}</span>
                            </li>
                        </ul>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
</nav>